// extracted by mini-css-extract-plugin
module.exports = {"row":"Config_row__1Dyg5","content":"Config_content__1b1Wv","additional":"Config_additional__fGCZB"};